module.exports = __webpack_public_path__ + "media/images/sp/brands/sola/store_hokkaido-c259e5002268b328218814a7c40ae474.jpg";